import * as ngCore from '@angular/core'

import * as content from '../../../../../../../content'

@ngCore.Component({
  imports: [content.display.variableList.Component],
  selector: 'atn-scenario-variables-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
